import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../../assets/css/customer/dashboard/CustomerDashboard.css";
import { checkLoggedInCustomer } from "../../../helper/CustomHelper";
import { useNavigate } from "react-router-dom";
import { useBaseUrl } from "../../../context/AppContext";

const CustomerDashboard = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useBaseUrl();

  const [customer, setCustomer] = useState(null);
  const [nextAppointment, setNextAppointment] = useState(null);
  const [activeDeals, setActiveDeals] = useState([]);
  const [recentActivity, setRecentActivity] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkLoggedInCustomer(navigate);

    const customerData = JSON.parse(localStorage.getItem("customer"));
    const escustomer_id = customerData?.id;

    axios
      .post(`${baseUrl}/customer/dashboard/getDashboardData`, {
        escustomer_id,
      })
      .then((res) => {
        setCustomer(res.data.customer);
        setNextAppointment(res.data.nextAppointment);
        setActiveDeals(res.data.activeDeals || []);
        setRecentActivity(res.data.recentActivity || []);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  const getItemName = (item) => {
    if (item.is_deal === "yes") {
      return item.esdeal?.title || "Deal";
    }
    return item.estreatment?.name || "Treatment";
  };

  const getItemImage = (item) => {
    const img =
      item.is_deal === "yes" ? item.esdeal?.image : item.estreatment?.image;
    return img ? `${baseUrlForFile}/${img}` : null;
  };

  const formatDate = (dateStr, timeStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const formatted = date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
    const time = timeStr ? timeStr.slice(0, 5) : "";
    return `${formatted} · ${time}`;
  };

  /* Countdown — appointment date tak kitne din baaki hain */
  const getDaysUntil = (dateStr) => {
    if (!dateStr) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const apptDate = new Date(dateStr);
    apptDate.setHours(0, 0, 0, 0);
    const diffDays = Math.round((apptDate - today) / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const renderCountdownLabel = (days) => {
    if (days === null) return null;
    if (days === 0) return "Today";
    if (days === 1) return "Tomorrow";
    if (days > 1) return `In ${days} days`;
    return "Past date";
  };

  if (loading) {
    return <p>Loading dashboard...</p>;
  }

  const daysUntil = nextAppointment
    ? getDaysUntil(nextAppointment.appointment_date)
    : null;

  return (
    <div>
      {/* ===== WELCOME ===== */}
      <h1 className="sgc-dash-welcome-title">
        Welcome back, {customer?.fullname || "Guest"}.
      </h1>
      <p className="sgc-dash-welcome-subtitle">
        Here's a quick look at your skin journey today.
      </p>

      {/* ===== TOP ROW ===== */}
      <div className="sgc-dash-top-row">
        {/* Next Appointment Card */}
        <div className="sgc-dash-next-appt-card">
          {nextAppointment ? (
            <>
              <div className="sgc-dash-next-appt-main">
                <div>
                  <p className="sgc-dash-next-appt-label">Next Appointment</p>
                  <h2 className="sgc-dash-next-appt-title">
                    {getItemName(nextAppointment)}
                  </h2>
                  <p className="sgc-dash-next-appt-date">
                    {formatDate(
                      nextAppointment.appointment_date,
                      nextAppointment.appointment_time,
                    )}
                  </p>
                  {/* Quick info row */}
                  <div className="sgc-dash-next-appt-tips">
                    <div className="sgc-dash-tip-item">
                      <span className="sgc-dash-tip-icon">💧</span>
                      <span>Stay hydrated 24 hrs before your session</span>
                    </div>
                    <div className="sgc-dash-tip-item">
                      <span className="sgc-dash-tip-icon">🧴</span>
                      <span>Avoid makeup on the day of treatment</span>
                    </div>
                    <div className="sgc-dash-tip-item">
                      <span className="sgc-dash-tip-icon">☀️</span>
                      <span>Use SPF 30+ before and after your visit</span>
                    </div>
                        <div className="sgc-dash-tip-item">
                      <span className="sgc-dash-tip-icon">✨</span>
                      <span>Wear loose, comfortable clothing to your treatment session.</span>
                    </div>
                  </div>
                </div>

                {daysUntil !== null && (
                  <span className="sgc-dash-countdown-badge">
                    {renderCountdownLabel(daysUntil)}
                  </span>
                )}
              </div>

              <div className="sgc-dash-next-appt-actions">
                <button
                  className="sgc-dash-btn-manage"
                  onClick={() => navigate("/customer/appointments")}
                >
                  Manage
                </button>
                <button
                  className="sgc-dash-btn-book-another"
                  onClick={() => navigate("/customer/book")}
                >
                  Book another
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="sgc-dash-empty-appt-content">
                <div className="sgc-dash-empty-appt-icon">🗓️</div>
                <p className="sgc-dash-next-appt-label">
                  No Upcoming Appointment
                </p>
                <h2 className="sgc-dash-next-appt-title">
                  Ready for your next glow-up?
                </h2>
                <p className="sgc-dash-next-appt-date">
                  You don't have anything scheduled right now. Book a treatment
                  and keep your skin journey going.
                </p>
              </div>
              <div className="sgc-dash-next-appt-actions">
                <button
                  className="sgc-dash-btn-manage"
                  onClick={() => navigate("/customer/book-appointment")}
                >
                  Book Now
                </button>
              </div>
            </>
          )}
        </div>

        {/* Active Deals Card */}
        <div className="sgc-dash-deals-card">
          <div className="sgc-dash-deals-header">
            <p className="sgc-dash-deals-header-title">Active Deals</p>
            <span
              className="sgc-dash-deals-see-all"
              onClick={() => navigate("/customer/deals")}
              style={{ cursor: "pointer" }}
            >
              See all
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </span>
          </div>

          {activeDeals.length === 0 ? (
            <p>No active deals right now.</p>
          ) : (
            activeDeals.map((deal) => (
              <div className="sgc-dash-deal-item" key={deal.id}>
                <div>
                  <p className="sgc-dash-deal-name">{deal.title}</p>
                  <p className="sgc-dash-deal-discount">{deal.discount}</p>
                </div>
                {deal.tag && (
                  <span className="sgc-dash-deal-badge">{deal.tag}</span>
                )}
              </div>
            ))
          )}
        </div>
      </div>

      {/* ===== RECENT ACTIVITY ===== */}
      <h2 className="sgc-dash-section-title">Recent treatment activity</h2>

      <div className="sgc-dash-activity-card">
        {recentActivity.length === 0 ? (
          <p>No recent activity found.</p>
        ) : (
          recentActivity.map((item) => {
            const statusClass =
              item.status === "Approved" || item.status === "complete"
                ? "sgc-dash-status-approved"
                : item.status === "Pending"
                  ? "sgc-dash-status-pending"
                  : "sgc-dash-status-cancelled";

            const imgSrc = getItemImage(item);

            return (
              <div className="sgc-dash-activity-item" key={item.id}>
                <div className="sgc-dash-activity-img">
                  {imgSrc ? (
                    <img
                      src={imgSrc}
                      alt={getItemName(item)}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  ) : (
                    "💆"
                  )}
                </div>
                <div className="sgc-dash-activity-info">
                  <p className="sgc-dash-activity-name">{getItemName(item)}</p>
                  <p className="sgc-dash-activity-date">
                    {formatDate(item.appointment_date, item.appointment_time)}
                  </p>
                </div>
                <span className={`sgc-dash-status-badge ${statusClass}`}>
                  {item.status}
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default CustomerDashboard;
